import { call, put, select, take } from 'redux-saga/effects';
import {
  APP_ORIGIN,
  SALESFORCE_CLIENT_ID,
} from '../../../../../../shared/config';
import { v4 } from 'uuid';

import { END, eventChannel } from 'redux-saga';
import {
  createNotification,
  snackbarModel,
} from '../../../../../../features/snackbar';
import { integrationsModel } from '../../..';
import { openOauthSignupPopup } from '../../../../../../utils/openOauthSignupPopup';
import { teamsModel } from '../../../../../../features/teams';
import { integrationsApi } from '../../../../../../shared/api/axios/integrations';
import { requestSalesforceToken } from './requestSalesforceToken';
import { logger } from '../../../../../../shared/lib';
import { getFullUrl } from '../../../../../../shared/lib';

const OAUTH_CALLBACK_URL = getFullUrl('auth-callback');
const SALESFORCE_AUTHORIZE_URL =
  'https://login.salesforce.com/services/oauth2/authorize';

export function* connectToSalesforce({
  payload: { cb },
}: ReturnType<typeof integrationsModel.actions.connectToSalesforce>): any {
  yield put(integrationsModel.actions.setIsConnectingToSalesforce(true));
  const state = v4();

  const { id: teamId } = yield select(
    teamsModel.selectors.selectCurrentTeamWithError
  );

  const challenge = yield call(
    integrationsApi.getSalesforcePkceParameters,
    teamId
  );

  const signUpPopup = openOauthSignupPopup(SALESFORCE_AUTHORIZE_URL, {
    response_type: 'code',
    client_id: SALESFORCE_CLIENT_ID,
    redirect_uri: OAUTH_CALLBACK_URL,
    state,
    code_challenge: challenge.code_challenge,
  });

  const callbackUrlChannel = yield call(
    checkConnectionModalForAuthCode,
    signUpPopup
  );

  let callbackUrl = '';

  try {
    while (true) {
      callbackUrl = yield take(callbackUrlChannel);
      if (callbackUrl) break;
    }
    yield call(onCallbackUrlSet, callbackUrl, state, challenge.code_verifier);
  } finally {
    cb?.();
    callbackUrlChannel.close();
    yield put(integrationsModel.actions.setIsConnectingToSalesforce(false));
  }
}

function* onCallbackUrlSet(
  callbackUrl: string,
  state: string,
  codeVerifier: string
) {
  try {
    yield call(requestSalesforceToken, callbackUrl, state, codeVerifier);

    yield call(teamsModel.sagas.refreshTeamsData);

    yield put(
      snackbarModel.actions.addNotificationAction(
        createNotification('success', 'Successfully connected to Salesforce')
      )
    );
  } catch (error) {
    logger.error(error);
    yield put(
      snackbarModel.actions.addNotificationAction(
        createNotification('error', 'Failed to connect to Salesforce')
      )
    );
  }
}

function checkConnectionModalForAuthCode(signUpPopup: Window | null) {
  return eventChannel((emitter) => {
    const checkSignUpPopupInterval = setInterval(() => {
      if (!signUpPopup || signUpPopup?.closed) {
        emitter(END);
        return;
      }
      try {
        if (signUpPopup?.window.location?.href.includes(APP_ORIGIN)) {
          emitter(signUpPopup.window.location.search);
          signUpPopup.close();
        }
      } catch {
        // nothing to do
      }
    }, 1000);

    return () => {
      clearInterval(checkSignUpPopupInterval);
    };
  });
}
